// extracted by mini-css-extract-plugin
export var container = "_sp-0";
export var table = "_sp-2";
export var tableWrapper = "_sp-1";